module.exports = __webpack_public_path__ + "img/putong.d6f5be89.png";